/* @flow */

import * as React from 'react';

import {colors} from 'shells/colors';
import {StackLegacy, Divider} from 'shells/layout';

type Props = {icon?: React.ComponentType<*>, children: React.Node};

export function ControlWithIcon(props: Props) {
    const Icon = props.icon;

    return (
        <>
            {Icon ? (
                <StackLegacy spacing={8} isHorizontal={true}>
                    <div
                        style={{
                            marginTop: 2,
                            marginLeft: 8,
                        }}
                    >
                        <Icon color={colors.grey} size={13} wrapWithDiv={false} />
                    </div>
                    <Divider variant='line--vertical' />
                </StackLegacy>
            ) : undefined}
            {props.children}
        </>
    );
}
